import Button from '@/components/Button';
import { Icon, IconVariant } from '@/components/Icon';
import Modal from '@/components/Modal';
import { kenoData } from '@/config/odds/oddsConfigs';
import numberToCurrency from '@/utilities/numberFormatter';
import React from 'react';

export interface GameKenoTypeInfoProps {
  selectedDrawRate: number;
  kenoType?: number | null;
}

export const GameKenoTypeInfo: React.FC<
  React.PropsWithChildren<GameKenoTypeInfoProps>
> = ({ selectedDrawRate, kenoType }) => {
  const data = kenoType && !!kenoData[kenoType] && kenoData[kenoType];

  const winQuote =
    data && data[0]['winningSum']
      ? numberToCurrency(+selectedDrawRate * data[0].winningSum, '€')
      : '?';

  return (
    <div className="GameKenoTypeInfo">
      <h3 className="Step__header h-flex-gm--justify-center-down">
        <span>
          <span>KENO-Typ {kenoType || '?'}</span>
          <Button
            onClick={() => Modal.open('keno-type-info')}
            iconPosition={Button.IconPosition.Right}
            ariaLabel="Weitere Informationen zu diesem KENO-Typ"
          >
            <Icon variant={IconVariant.Info} />
          </Button>
        </span>
      </h3>
      <div className="GameKenoTypeInfo__box">
        <div>Maximaler Gewinn: {winQuote}</div>
        <div>Bei Einsatz: {selectedDrawRate} €</div>
      </div>
    </div>
  );
};
